import { useEffect, useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { authApi } from '../services/api'

interface UtenteOnline {
  id: number
  nome?: string
  cognome?: string
  email: string
  role: string
  last_seen_at: string
}

const COLORI = ['#1E40AF', '#7c3aed', '#0d9488', '#F97316', '#dc2626', '#15803d', '#f59e0b']

function coloreAvatar(id: number) {
  return COLORI[id % COLORI.length]
}

function iniziali(u: UtenteOnline) {
  const n = (u.nome || u.email)[0] || '?'
  const c = (u.cognome || '')[0] || ''
  return (n + c).toUpperCase()
}

export function OnlineUsersWidget() {
  const { user } = useAuth()
  const [utenti, setUtenti] = useState<UtenteOnline[]>([])
  const [aperto, setAperto] = useState(false)

  useEffect(() => {
    if (!user) return
    const carica = () => {
      authApi.utentiOnline().then(r => setUtenti(r.data)).catch(() => {})
    }
    carica()
    const t = setInterval(carica, 30_000)
    return () => clearInterval(t)
  }, [user])

  if (utenti.length === 0) return null

  const visibili = utenti.slice(0, 4)
  const altri = utenti.length - visibili.length

  return (
    <div style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={() => setAperto(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', gap: 6,
          background: 'transparent', border: 'none', cursor: 'pointer', padding: 4,
        }}
        title={`${utenti.length} ${utenti.length === 1 ? 'utente connesso' : 'utenti connessi'}`}
      >
        <div style={{ display: 'flex' }}>
          {visibili.map((u, i) => (
            <div key={u.id} style={{
              width: 26, height: 26, borderRadius: '50%',
              background: coloreAvatar(u.id), color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 10, fontWeight: 700, border: '2px solid #fff',
              marginLeft: i === 0 ? 0 : -8,
            }}>
              {iniziali(u)}
            </div>
          ))}
          {altri > 0 && (
            <div style={{
              width: 26, height: 26, borderRadius: '50%',
              background: '#e2e8f0', color: '#475569',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 9.5, fontWeight: 700, border: '2px solid #fff',
              marginLeft: -8,
            }}>
              +{altri}
            </div>
          )}
        </div>
        <span style={{ fontSize: 11, color: 'var(--mac-label-2)', fontWeight: 600 }}>
          {utenti.length} online
        </span>
      </button>

      {aperto && (
        <>
          <div onClick={() => setAperto(false)} style={{ position: 'fixed', inset: 0, zIndex: 40 }} />
          <div style={{
            position: 'absolute', top: '100%', right: 0, marginTop: 6,
            background: '#fff', borderRadius: 12, boxShadow: '0 8px 30px rgba(0,0,0,.14)',
            border: '1px solid rgba(0,0,0,0.08)', padding: 8, minWidth: 220,
            maxHeight: 280, overflowY: 'auto', zIndex: 41,
          }}>
            {utenti.map(u => (
              <div key={u.id} style={{
                display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', borderRadius: 8,
              }}>
                <div style={{
                  width: 24, height: 24, borderRadius: '50%', flexShrink: 0,
                  background: coloreAvatar(u.id), color: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 9.5, fontWeight: 700,
                }}>
                  {iniziali(u)}
                </div>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={{ fontSize: 12.5, fontWeight: 600, color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {u.nome || u.email} {u.cognome || ''} {u.id === user?.id && <span style={{ color: '#94a3b8', fontWeight: 500 }}>(tu)</span>}
                  </div>
                  <div style={{ fontSize: 10.5, color: '#94a3b8', textTransform: 'capitalize' as const }}>
                    {u.role}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
